import { render, staticRenderFns } from "./PolyToSVG.vue?vue&type=template&id=4f1ddf80"
import script from "./PolyToSVG.vue?vue&type=script&lang=js"
export * from "./PolyToSVG.vue?vue&type=script&lang=js"
import style0 from "./PolyToSVG.vue?vue&type=style&index=0&id=4f1ddf80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports